import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/storage'
import 'firebase/functions'

const firebaseConfig = {
  apiKey: 'AIzaSyCP7YtRXgooe_vrhlVLQCbCfunOL9YCt5U',
  authDomain: 'amecos.firebaseapp.com',
  projectId: 'amecos',
  storageBucket: 'amecos.firebasestorage.app',
  messagingSenderId: '133878781361',
  appId: '1:133878781361:web:3eec385da93e9b6b6c1990',
}

firebase.initializeApp(firebaseConfig)

const firebaseSideEffect = firebase.initializeApp(firebaseConfig, 'Side Effect instance')

const db = firebase.firestore()
const storageRef = firebase.storage().ref()
const { storage } = firebase
const functions = firebase.app().functions('europe-west3')

export { db, storage, storageRef, firebase, firebaseSideEffect, functions }
